<template>
  <div class="questionblock">
    <div class="item" v-for="(options, index) in printSplitJson()" :key="index">
      <button @click="buttonPressed(index + 1)" class="questionButton">{{ index + 1 }}) {{ options }}</button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  myQuestions: null,
  setNumber: Number,
 // message: null,
})

const emit = defineEmits(['get-message']);


function printSplitJson() {
      let answerOptions =
        props.myQuestions.questions[props.setNumber].options;
      //console.log(answerOptions);
      return answerOptions;
}

function buttonPressed(buttonContent) {
  //emit('focus');
   emit('get-message', buttonContent);
   //this.$parent.focusInput();
}
</script>


<style scoped>
p{
  color:green;
}

.questionblock {
  display:flex;     
  grid-gap: 1rem;
  width: 80%;
  height: 100%;
  top: 20%;
}
.questionButton {
  position: relative;
  font-size: 1rem;
  font-family: monospace;
  left: 0%;
  top: 0%;
  border: 2px solid black;
  width: 100%;
  height: 50%;
  color: #0f0;
  text-align: left;
  background-color: black;
}
@media all and (min-width: 600px) {
  .questionButton {
    font-size: 1.5rem;
  }

}

</style>